import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import mascot from '../../assets/images/mascot-hero.webp';

export default function ClosingCTA() {
  return (
    <section className="fi-cta" aria-labelledby="fi-cta-h" data-track-context="home_closing_cta">
      <div className="fi-seal" aria-hidden="true">
        <svg viewBox="0 0 200 200">
          <circle cx="100" cy="100" r="96" fill="#111" />
          <circle cx="100" cy="100" r="58" fill="#D7140F" />
          <path id="fi-seal-path" d="M100,100 m-76,0 a76,76 0 1,1 152,0 a76,76 0 1,1 -152,0" fill="none" />
          <text fill="#FFE600" fontFamily="Anton, Impact, sans-serif" fontSize="21" letterSpacing="3.4">
            <textPath href="#fi-seal-path">FREE START TO FINISH · NO DEALER BS · </textPath>
          </text>
          <text x="100" y="114" textAnchor="middle" fill="#fff" fontFamily="Anton, Impact, sans-serif" fontSize="40">$0</text>
        </svg>
      </div>
      <div className="fi-wrap">
        <h2 className="fi-h-big fi-ant" id="fi-cta-h"><span>Done nodding along?</span><span>Go get one.</span></h2>
        <p>We'll match you to the right EV and, when a dealer hands you a number, tell you exactly what's wrong with it. Free, start to finish.</p>
        <RouterLink className="fi-btn fi-btn--ink" to="/concierge" onClick={() => { if (window.gtag) window.gtag('event', 'home_cta_concierge', {}); }}>
          Get help buying an EV, free
        </RouterLink>
        <p className="fi-fine">Real talk on money: the tools are free and we don't sell your email. Charger links may earn us a small commission. That's it. If that ever changes, this line changes first.</p>
        <div className="fi-peekwrap" aria-hidden="true">
          <div className="fi-peek"><img src={mascot} width="300" height="436" alt="" loading="lazy" /></div>
          <span className="fi-say">Wait. It's free?</span>
        </div>
      </div>
    </section>
  );
}
